import { render, staticRenderFns } from "./HoursBankDashboardItem.vue?vue&type=template&id=70c874ac&scoped=true"
import script from "./HoursBankDashboardItem.vue?vue&type=script&lang=js"
export * from "./HoursBankDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./HoursBankDashboardItem.vue?vue&type=style&index=0&id=70c874ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c874ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
